













import Vue from 'vue'
import { Component, Prop } from 'vue-property-decorator'
import BaseSelectInput from '@/components/BaseSelectInput.vue';

@Component<SelectOptionSelector>({
  components: {BaseSelectInput}
})
export default class SelectOptionSelector extends Vue {
  @Prop({ type: Array, required: true }) private options!: []
  @Prop({ type: String }) private selected
  @Prop({ type: Boolean }) private readOnly

  public isOpen = false

  public get getOptions() {
    const options = [] as object[]

    for (const option of this.options) {
      options.push({
        value: option,
        label: option,
        disabled: false
      })
    }

    return options
  }
}
